export const links = [
  { title: "Galleries", path: "/galleries" },
  { title: "Artworks", path: "/artworks" },
  // { title: "Spaces", path: "/spaces" },
  { title: "Virtual Exhibitions", path: "/exhibitions" },
  // { title: "Contact", path: "/contact" },
]
